import { BusinessProspectType } from './business-prospect-type';

export class BusinessProspectConfiguration {
    public type: BusinessProspectType = BusinessProspectType.RequestInfo;
    public projectId: number = 0;
    public pricingId: number = 0;
    public priceToCharge: string = '';

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }
}
